import {COLORS} from '@fupa/fupa-uikit';
import {ChevronRight} from '@mui/icons-material';
import {Button} from '@mui/material';
import React from 'react';
import {ColoredTypography} from '../cards/CardStyles';

const FreeTrialButton = () => {
  return (
    <>
      <Button endIcon={<ChevronRight />} variant='contained' component='a' href='/builder'>
        Jetzt ausprobieren
      </Button>
      <ColoredTypography color={COLORS.lightGrey} variant='caption2' component='p'>
        Um ein Widget zu speichern, Code zu generieren oder Styles individuell anzupassen, ist ein FuPa-Konto nötig.
      </ColoredTypography>
    </>
  );
};

export default FreeTrialButton;
